import Axios from 'axios';
import { UrlUtils } from '@garmin/support-utils';

// eslint-disable-next-line import/prefer-default-export
export const capi = Axios.create({
  baseURL: `${UrlUtils.getBaseUrl()}/capi`,
  headers: {
    'x-csrf-token': window?.AppData?.csrf,
  },
});

capi.interceptors?.response.use((resp) => resp, (error) => {
  const errRespData = error?.response?.data;
  if (errRespData?.invalidSession && errRespData?.internal) setTimeout(() => window.location.reload(), 250);
  return Promise.reject(error);
});
